const adaptUserData = (data, labels)=>{
    const user = [];
    const { firstName , lastName , email , phone , child  } = data;
    user.push({
        label: labels.name,
        value: `${firstName !== null && firstName !== void 0 ? firstName : ''} ${lastName !== null && lastName !== void 0 ? lastName : ''}`.trim()
    });
    var ref, ref1;
    user.push({
        label: labels.child,
        value: `${(ref = child === null || child === void 0 ? void 0 : child.firstName) !== null && ref !== void 0 ? ref : ''} ${(ref1 = child === null || child === void 0 ? void 0 : child.lastName) !== null && ref1 !== void 0 ? ref1 : ''}`.trim()
    });
    user.push({
        label: labels.email,
        value: email !== null && email !== void 0 ? email : ''
    });
    user.push({
        label: labels.phone,
        value: phone !== null && phone !== void 0 ? phone : ''
    });
    return user.filter((el)=>el.value !== ''
    );
};

export { adaptUserData };
//# sourceMappingURL=adapters.js.map
